import React from 'react';
import { connect } from 'react-redux';
import styled from '@emotion/styled';
import posed from 'react-pose';

import { drawHead as colors } from 'config/paletteConfig';
import { pointConfig } from 'config/pointConfig';
import { RootState } from 'reducers/rootReducer';
import { CoordinatePoint } from 'types/point';
import { selectors as editModeSelectors } from 'ducks/editMode';
import { selectors as drawSelectors } from 'ducks/draw/draw';
import { circleGlow } from 'components/animations';
import { selectors as viewPointSelectors } from 'ducks/viewport';
import { ReactComponent as crosshair } from 'assets/icons/cursor-crosshair.svg';
import { selectors as drawWithKeypadSelectors } from 'ducks/draw/drawWithKeypad';


const RADIUS_FACTOR = 2;

interface StateProps {
  readonly isEditMode: boolean;
  readonly drawAnchorPoint: CoordinatePoint | null;
  readonly zoomInPercent: number;
  readonly isNumpadLocked: boolean;
}

type Props = StateProps;

const Circle = styled.circle({
  strokeWidth: 2,
  stroke: colors.stroke,
  fill: colors.base,
  pointerEvents: 'none',
});

const Dot = styled.circle({
  fill: 'black',
  pointerEvents: 'none',
});

const CrossHair = styled(crosshair)``;
const CrossHairSize = 48;

const GlowingCircle = posed(Circle)(circleGlow);

const AnchorHead: React.FC<Props> = ({ isEditMode, drawAnchorPoint, zoomInPercent, isNumpadLocked }) => isEditMode ? (
  <>
    <GlowingCircle
      r={pointConfig.getRadiusAutoFinish(zoomInPercent) / RADIUS_FACTOR}
      cx={(drawAnchorPoint) ? drawAnchorPoint.x : 0}
      cy={(drawAnchorPoint) ? drawAnchorPoint.y : 0}
      initialPose="hide"
      pose="show"
    />
    <Dot
      r={pointConfig.getRadiusAutoFinish(zoomInPercent) / (6 * RADIUS_FACTOR)}
      cx={(drawAnchorPoint) ? drawAnchorPoint.x : 0}
      cy={(drawAnchorPoint) ? drawAnchorPoint.y : 0}
    />
    {isNumpadLocked && (
      <CrossHair
        width={CrossHairSize}
        height={CrossHairSize}
        x={(drawAnchorPoint) ? drawAnchorPoint.x - CrossHairSize / 2 : -CrossHairSize / 2}
        y={(drawAnchorPoint) ? drawAnchorPoint.y - CrossHairSize / 2 : -CrossHairSize / 2}
      />
    )}
  </>
) : null;

export default connect(
  (state: RootState): StateProps => ({
    isEditMode: editModeSelectors.isEditMode(state),
    drawAnchorPoint: drawSelectors.getCurserPoint(state),
    zoomInPercent: viewPointSelectors.getZoomInPercent(state),
    isNumpadLocked: drawWithKeypadSelectors.getNumpadLocked(state),
  }),
)(AnchorHead);
